import { OrgInterface } from '@swivl-mono/types';
import { APIService } from '../Service/API.Service';
// LINK apps/server/src/API/S3/S3.Controller.ts
export class S3API {

    
  static async getAnalyticsReportURLs(orgId: number):Promise<{link: string, name: string}[]> {
    return APIService.Server.get<{link: string, name: string}[]>(`/s3/org/${orgId}/analytics-file-list`);
    // return APIService.Notifications.get<boolean>(`/org/${orgId}/agent/${agentId}/availability`);
  }
  

  
}
